/*
 * @Author: edvardchen
 * @Date:   2016-11-18 17:10:39
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-12-17 21:23:24
 */

// @flow
import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import { listen } from 'fbjs/lib/EventListener';

import querystring from 'query-string';

const DEFAULT_HW_RATIO = 9 / 16; // 16:9 高宽比

const formatSrc = (src) => {
  const parts = src.split('?');
  if (parts.length < 2) {
    return parts[0];
  }

  // remove HW info to support resize event
  const qs = querystring.parse(parts[1]);
  delete qs.width;
  delete qs.height;
  return `${parts[0]}?${querystring.stringify(qs)}`;
};

type Props = {
  height: number,
  width: number,
  src: string,
};

type State = {
  height?: number,
  width?: number,
  ratio?: number,
  src?: string,
};

/* global HTMLElement */
export default class VideoIframe extends React.Component<Props, State> {
  //
  watchResize: Function;

  el: ?HTMLElement;

  constructor(props: Props) {
    super(props);
    const { height, width } = props;

    let ratio = DEFAULT_HW_RATIO;
    if (width && height) {
      ratio = height / width;
    }

    this.state = {
      ratio,
    };
  }

  componentDidMount() {
    if (this.el && this.props.src) {
      setTimeout(this.setStateInContainer);
      this.watchResize = listen(window, 'resize', () => {
        this.setStateInContainer();
      });
    }
  }

  componentWillUnmount() {
    this.watchResize && this.watchResize.remove();
  }

  @autobind
  setStateInContainer() {
    const { ratio } = this.state;
    if (!this.el || !ratio) {
      return;
    }
    const { offsetParent } = this.el;
    if (!offsetParent) {
      return;
    }
    const width = offsetParent.clientWidth;
    const height = Math.ceil(width * ratio);
    const src = formatSrc(this.props.src, width, height);
    this.setState({
      width,
      height,
      src,
    });
  }

  render() {
    const { width, height, src } = this.state;
    if (!width || !height) {
      return (
        <span
          ref={(node) => {
            this.el = node;
          }}
        />
      ); // for access to parent element
    }
    return (
      <iframe
        ref={(node) => {
          this.el = node;
        }}
        width={width}
        height={height}
        src={src}
      ></iframe>
    );
  }
}
